// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../common/temp/node_modules/.pnpm/css-loader@3.6.0_webpack@4.46.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loadercss{width:15%}@media screen and (max-width:767px){.loadercss{width:20%!important}}.loadertextcss{font-size:18px;color:#073262}", ""]);
// Exports
module.exports = exports;
